<template>
  <div class="admin-reports-container">
    <select-farm-header
      title="Admin Reports"
      :showFarmSearchText="false"
      :showAddFarmButton="false"
    />

    <div class="admin-reports-page">
      <div class="page-header">
        <div class="header-actions">
          <button @click="exportCSV" class="export-button">
            <i class="fa fa-file-text-o"></i>
            CSV Exports
          </button>
        </div>
      </div>
      <HierarchicalReportView />
    </div>
  </div>
</template>

<script setup>
import AdminReportsDialog from '@/views/AdminReportsDialog'
import HierarchicalReportView from '@/components/HierarchicalReportView.vue'
import SelectFarmHeader from '@/components/SelectFarmHeader.vue'
import { inject } from 'vue'

const $dialog = inject('$dialog')

function exportCSV() {
  $dialog.push(AdminReportsDialog)
}
</script>

<style scoped>
.admin-reports-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--bg1);
  z-index: 100;
}

.admin-reports-page {
  margin: 0 auto;
  padding: var(--general-padding);
  flex: 1;
}

.page-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--accent0);
}

.header-actions {
  display: flex;
  gap: 12px;
}

.export-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: var(--accent1);
  color: white;
  border: none;
  border-radius: var(--general-border-radius);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: opacity 0.2s;
}

.export-button:hover {
  opacity: 0.8;
}

.export-button i {
  font-size: 16px;
}
</style>
